import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../components/Button/Button";
import Text from "../../components/Text/Text";
import MoreHorizontal from "../../components/Svg/Icons/MoreHorizontal";
import { ButtonProps } from "../../components/Button";
import { connectorLocalStorageKey, walletLocalStorageKey } from "./config";
import { Login, Config } from "./types";

interface Props {
  walletConfig: Config;
  login: Login;
  onDismiss: () => void;
  setView: (view: number) => void;
  setWalletActive: (input: any) => void;
  active?: boolean;
}

const WalletButton = styled(Button).attrs({ width: "100%", variant: "text", py: "16px" })`
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  flex-direction: row;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  padding: 7px 22px;

  &:hover {
    background: rgba(187, 187, 187, 0.5) !important;
  }

  &:active {
    background: #006dfe;
  }

  &.active {
    background: #006dfe;
    opacity: 1 !important;

    .wallet-title {
      color: #ffffff;
    }
  }

  .wallet-title {
    color: #000000;
  }

  &.active {
    .wallet-title {
      background: #006dfe !important;
    }
  }
`;

interface MoreWalletCardProps extends ButtonProps {
  t: (key: string) => string;
}

export const MoreWalletCard: React.FC<MoreWalletCardProps> = ({ t, ...props }) => {
  return (
    <WalletButton variant="tertiary" {...props}>
      <MoreHorizontal width="25px" mr="9px" color="textSubtle" />
      <Text fontSize="14px">{t("More")}</Text>
    </WalletButton>
  );
};

const WalletCard: React.FC<Props> = ({ login, walletConfig, onDismiss, setView, setWalletActive, active }) => {
  const { title, icon: Icon } = walletConfig;
  const { isLogin } = useSelector((state: any) => state.auth);

  const handleConnect = async () => {
    setWalletActive(title);

    if (!window.ethereum && title === "Metamask" && walletConfig.href) {
      window.open(walletConfig.href, "_blank", "noopener noreferrer");
    } else {
      const loginCheck: any = await login(walletConfig.connectorId);
      localStorage?.setItem(walletLocalStorageKey, walletConfig.title);
      localStorage?.setItem(connectorLocalStorageKey, walletConfig.connectorId);

      if (loginCheck && !isLogin) {
        setView(1);
      } else {
        onDismiss();
      }
    }
  };

  useEffect(() => {
    if (isLogin) {
      onDismiss();
    }
  }, [isLogin, onDismiss]);

  return (
    <WalletButton
      className={active ? "active" : ""}
      variant="tertiary"
      onClick={() => handleConnect()}
      id={`wallet-connect-${title.toLocaleLowerCase()}`}
    >
      <Icon width="25px" mr="9px" />
      <Text className="wallet-title" fontSize="14px">
        {title}
      </Text>
    </WalletButton>
  );
};

export default WalletCard;
